import {
  DatePicker,
  Button,
  Form,
  Input,
  Row,
  Col,
  Select,
  InputNumber,
} from "antd";
import { useTranslation } from "react-i18next";
import {
  MailOutlined,
  FileTextOutlined,
  IdcardOutlined,
} from "@ant-design/icons";


export default function ExpenseTypeForm({ form, onSubmit }) {
  const { t } = useTranslation();

  return (
    <Form   layout="vertical"
    name="depensetype-Form"
    id="depensetype-Form"
    form={form}
    onFinish={onSubmit}
    style={{
      maxWidth: 600,
      margin: "0 auto",
      marginTop: "30px",
      padding: "20px",

      background: "#fff",
    }}>
        <Row gutter={16}>
              {/* Champ Nom */}
              <Col xs={24} md={12}>
      <Form.Item
        label={  <span style={{ fontWeight: "bold", color: "#333" }}>
        {t("expenseTypes.form.type")}
      </span>}
        name="type"
        rules={[
          { required: true, message: t("expenseTypes.form.errors.typeRequired") },
          { min: 3, message: t("expenseTypes.form.errors.typeMinLength") }
        ]}
      >
        <Input className="custom-input"
              style={{
                borderRadius: "8px",
                padding: "10px",
                border: "1px solid #ddd",
                boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1)",
                height: "40px", // Assure que la hauteur est la même
              }} 
              placeholder={t("expenseTypes.form.placeholders.type")} />
      </Form.Item>
      </Col>

      <Col>
      <Form.Item
        label={  <span style={{ fontWeight: "bold", color: "#333" }}>
        {t("expenseTypes.form.description")}
      </span>
    }
        name="description"
        rules={[
          { required: true, message: t("expenseTypes.form.errors.descriptionRequired") },
          { min: 5, message: t("expenseTypes.form.errors.descriptionMinLength") }
        ]}
      >
        <Input.TextArea
          prefix={<FileTextOutlined style={{ color: "#f3db56" }} />}
            className="custom-input"
          rows={4}
          style={{
            borderRadius: "8px",
            padding: "10px",
            border: "1px solid #ddd",
            boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1)",
            resize: "none",
          }}
          placeholder={t("expenseTypes.form.placeholders.description")}
        />
      </Form.Item>
      </Col>
      </Row>
    </Form>
  );
}